import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Crud } from '@awp/shared/Crud';

const AwpYesNoModal = ({ showYesNoModal, setShowYesNoModal, onClickYes, title, body }) => {
  const crud = new Crud();
  const close = () => setShowYesNoModal(false);

  return (
    <Modal
      show={showYesNoModal}
      animation={false}
      onHide={close}
      backdrop="static"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>{crud.getModalTitle({ title })}</Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClickYes}>
          Yes
        </Button>
        <Button variant="secondary" onClick={close}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AwpYesNoModal.propTypes = {
  showYesNoModal: PropTypes.bool,
  setShowYesNoModal: PropTypes.func,
  onClickYes: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.any,
};

export default AwpYesNoModal;
